<table *ngIf="trainingProvided?.From && trainingProvided?.To" class="ir-plugin-table" style="margin-bottom: 10px">
  <tr>
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationtrainingprovided.training-conducted' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span>
          {{ 'plugins.installationtrainingprovided.from' | translate }}
          {{ trainingProvided?.From | formatDate }} {{ 'plugins.installationtrainingprovided.to' | translate }}
          {{ trainingProvided?.To | formatDate }}
        </span>
      </p>
    </td>
  </tr>
</table>
<table *ngFor="let item of trainingProvided?.CustomerAttendees" class="ir-plugin-table" style="margin-bottom: 10px">
  <tr>
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong> {{ item.FirstName }} {{ item.Lastname }}, {{ item.Company }}, {{ item.JobFunction }} </strong>
      </span>
    </td>
    <td></td>
  </tr>
  <tr>
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong> {{ 'plugins.installationtrainingprovided.use-of-doc' | translate }} </strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p *ngIf="item?.UseOfDocumentation != null">
        <span>{{
          (item?.UseOfDocumentation ? 'plugins.response.boolean.true' : 'plugins.response.boolean.false') | translate
        }}</span>
      </p>
    </td>
  </tr>
  <tr>
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong> {{ 'plugins.installationtrainingprovided.safety-devices' | translate }} </strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p *ngIf="item?.SafetyDevices != null">
        <span>{{
          (item.SafetyDevices ? 'plugins.response.boolean.true' : 'plugins.response.boolean.false') | translate
        }}</span>
      </p>
    </td>
  </tr>
  <tr>
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong> {{ 'plugins.installationtrainingprovided.machine-op-and-control' | translate }} </strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p *ngIf="item?.MachineOpAndControl != null">
        <span>{{
          (item.MachineOpAndControl ? 'plugins.response.boolean.true' : 'plugins.response.boolean.false') | translate
        }}</span>
      </p>
    </td>
  </tr>
  <tr>
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong> {{ 'plugins.installationtrainingprovided.maintenance' | translate }} </strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p *ngIf="item?.Maintenance != null">
        <span>{{
          (item.Maintenance ? 'plugins.response.boolean.true' : 'plugins.response.boolean.false') | translate
        }}</span>
      </p>
    </td>
  </tr>
</table>
